var _defs, _path, _g, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutplayicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12815",
    "data-name": "Group 12815",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 204.733,
    height: 204.734,
    viewBox: "0 0 204.733 204.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_54382",
    x: 12.138,
    y: 12.573,
    width: 181.125,
    height: 181.125,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#1a1818",
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_54381",
    "data-name": "Path 54381",
    d: "M102.367,0A102.367,102.367,0,1,1,0,102.367,102.367,102.367,0,0,1,102.367,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_54382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54382-2",
    "data-name": "Path 54382",
    d: "M77.062,0A77.062,77.062,0,1,1,0,77.062,77.062,77.062,0,0,1,77.062,0Z",
    transform: "translate(25.64 25.07)",
    fill: "#ce0024"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_65580",
    "data-name": "Path 65580",
    d: "M1226.842,139.137l.037-27.105.037-27.105,23.456,13.585,23.456,13.585-23.493,13.521Z",
    transform: "translate(-1148.166 -9.709)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutplayicon);
export default __webpack_public_path__ + "static/media/aboutplayicon.f46445a2123b95b53862932fc3720910.svg";
export { ForwardRef as ReactComponent };